import { z } from 'zod';

import { EmployeeRole } from '@/common/graphql';

export const AuthUser = z.object({
  sub: z.string().default(''),
  name: z.string().default(''),
  email: z.string().default(''),
  role: z.nativeEnum(EmployeeRole).default(EmployeeRole.Basic),
  pictureUrl: z.string().default(''),
  exp: z.number().default(0),
});

export type AuthUserType = z.infer<typeof AuthUser>;
